import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as n, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconUmbrella",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.714 2.423a5.461 5.461 0 0 1 1.784 3.528A.5.5 0 0 1 11 6.5H6.5V10a.5.5 0 0 0 1 0 .5.5 0 0 1 1 0 1.5 1.5 0 0 1-3 0V6.5H1a.5.5 0 0 1-.498-.549 5.461 5.461 0 0 1 1.784-3.528 5.56 5.56 0 0 1 3.198-1.398L5.486.97a.509.509 0 1 1 1.018 0v.053a5.56 5.56 0 0 1 3.21 1.4ZM1.586 5.5a4.46 4.46 0 0 1 1.368-2.333 4.56 4.56 0 0 1 6.092 0A4.46 4.46 0 0 1 10.414 5.5H1.586Z",
  fill: "currentColor"
}, null, -1), m = [
  h
], f = ["id"], p = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function b(a, v, l, I, q, t) {
  return n(), d("svg", {
    "aria-label": l.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--umbrella"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Umbrella",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, m, 8, _),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, g, 8, f)
    ])
  ], 10, u);
}
const C = /* @__PURE__ */ s(c, [["render", b]]);
export {
  C as default
};
//# sourceMappingURL=umbrella.js.map
